import { render, staticRenderFns } from "./TheDescription.vue?vue&type=template&id=43e70285&scoped=true"
import script from "./TheDescription.vue?vue&type=script&lang=ts"
export * from "./TheDescription.vue?vue&type=script&lang=ts"
import style0 from "./TheDescription.vue?vue&type=style&index=0&id=43e70285&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e70285",
  null
  
)

export default component.exports